import { useTranslation } from "react-i18next";

const ItemState = ({ item, className }) => {
  const { t } = useTranslation();
  let cssClass = "";

  if (item.state === "validated") {
    cssClass = "bg-bioport-orange text-white";
  } else if (item.state === "online") {
    cssClass = "bg-green-600 text-white";
  } else {
    cssClass = "bg-gray-200";
  }

  return (
    <span className={`rounded ${cssClass} ${className}`}>
      {t("items.state." + item.state)}
    </span>
  );
};

export default ItemState;
